import { Button } from "@mui/material";

import React from "react";

import I18nLink from "../I18nLink";

export type BasicTag = {
    name: string;
    path: string;
    slug: string;
};

type Props = Omit<BasicTag, "slug">;

const Tag = ({ name, path }: Props): React.ReactElement => (
    <Button
        href={path}
        component={I18nLink}
        variant="contained"
        color="primary"
        sx={{ boxShadow: 0 }}
    >
        {name}
    </Button>
);

export default Tag;
